/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstanceWithZone } from "./ForcingSubstanceWithZone";
import {
  ForcingSubstanceWithZoneFromJSON,
  ForcingSubstanceWithZoneFromJSONTyped,
  ForcingSubstanceWithZoneToJSON,
  ForcingSubstanceWithZoneToJSONTyped,
} from "./ForcingSubstanceWithZone";
import type { LocalRainUnitEnum } from "./LocalRainUnitEnum";
import {
  LocalRainUnitEnumFromJSON,
  LocalRainUnitEnumFromJSONTyped,
  LocalRainUnitEnumToJSON,
  LocalRainUnitEnumToJSONTyped,
} from "./LocalRainUnitEnum";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface PatchedTimeseriesLocalRain
 */
export interface PatchedTimeseriesLocalRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  values?: Array<Array<number>>;
  /**
   *
   */
  interpolate?: boolean;
  /**
   * m/s is only option for now
   *
   * * `m/s` - meter_per_second
   * * `mm/h` - millimeter_per_hour
   * * `mm/min` - millimeter_per_minute
   */
  units?: LocalRainUnitEnum;
  /**
   *
   */
  diameter?: number;
  /**
   *
   */
  point?: Point;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstanceWithZone>;
}

/**
 * Check if a given object implements the PatchedTimeseriesLocalRain interface.
 */
export function instanceOfPatchedTimeseriesLocalRain(
  value: object
): value is PatchedTimeseriesLocalRain {
  return true;
}

export function PatchedTimeseriesLocalRainFromJSON(json: any): PatchedTimeseriesLocalRain {
  return PatchedTimeseriesLocalRainFromJSONTyped(json, false);
}

export function PatchedTimeseriesLocalRainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedTimeseriesLocalRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"] == null ? undefined : json["offset"],
    values: json["values"] == null ? undefined : json["values"],
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    units: json["units"] == null ? undefined : LocalRainUnitEnumFromJSON(json["units"]),
    diameter: json["diameter"] == null ? undefined : json["diameter"],
    point: json["point"] == null ? undefined : PointFromJSON(json["point"]),
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceWithZoneFromJSON),
  };
}

export function PatchedTimeseriesLocalRainToJSON(json: any): PatchedTimeseriesLocalRain {
  return PatchedTimeseriesLocalRainToJSONTyped(json, false);
}

export function PatchedTimeseriesLocalRainToJSONTyped(
  value?: Omit<PatchedTimeseriesLocalRain, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    values: value["values"],
    interpolate: value["interpolate"],
    units: LocalRainUnitEnumToJSON(value["units"]),
    diameter: value["diameter"],
    point: PointToJSON(value["point"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceWithZoneToJSON),
  };
}
